import React from 'react';

import { RibbonBar } from 'common/components';
import { ViewLayout, AdvanceStack } from './components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import PublicationSection from './components/sections/product/PublicationSection';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const PublicationGridView = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled={true} />
      <Can I={ABILITY_ACTION.EDIT} a={ABILITY_SUBJECT.PRODUCT}>
        <PublicationSection />
      </Can>
      <AdvanceStack isDisabled={true} />
    </RibbonBar>
  );
};

export default PublicationGridView;
